require('apply!callback!./components.js');



/** WEBPACK FOOTER **
 ** ./frontend/main.js
 **/